// the constants module is provided by backed in our index.php.
// here we just export the name to have a nice way to import this module
export default 'nw.constants';
